// LoadGradingSession.jsx
import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useGetGradingSessionQuery, useGetGradingSessionDataQuery } from '../../slices/authApi';
import { 
  initAssignmentData, 
  initRubricData, 
  initSampleWorkData, 
  setAssignmentId,
  setRubricId,
  setSampleWorkId,
  selectSampleWorkData,
} from '../../slices/gradingForm';

const LoadGradingSession = () => {
  const { sessionId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sampleWorkData = useSelector(selectSampleWorkData);
  
  // First, get the session IDs
  const { 
    data: sessionIds, 
    isLoading: isLoadingIds, 
    isError: isErrorIds 
  } = useGetGradingSessionQuery(sessionId);

  // Then, use the IDs to get the full session data
  const { 
    data: sessionData, 
    isLoading: isLoadingData, 
    isError: isErrorData 
  } = useGetGradingSessionDataQuery(
    { 
      assignment_id: sessionIds?.assignment_id, 
      rubric_id: sessionIds?.rubric_id, 
      sample_work_id: sessionIds?.sample_work_id 
    }, 
    { skip: !sessionIds } // Skip this query until we have the IDs
  );

  useEffect(() => {
    if (sessionIds && sessionData) {
      // Set the IDs
      dispatch(setAssignmentId(sessionIds.assignment_id));
      dispatch(setRubricId(sessionIds.rubric_id));
      dispatch(setSampleWorkId(sessionIds.sample_work_id));

      // Populate the Redux store with the loaded session data
      dispatch(initAssignmentData(sessionData?.assignment));
      dispatch(initRubricData(sessionData?.rubric));
      dispatch(initSampleWorkData(sessionData?.sample_work));

      // Navigate to the appropriate step in the grading process
      // TODO: This could be determined based on the loaded data
      navigate('/grading/assignment');
      sessionStorage.setItem("showModal", "true");
    }
  }, [sessionIds, sessionData, dispatch, navigate]);

  if (isLoadingIds || isLoadingData) return <div>Loading session...</div>;
  if (isErrorIds || isErrorData) return <div>Error loading session</div>;


  

  return null; // This component doesn't render anything itself
};

export default LoadGradingSession;